import React from 'react';
import {useAppSelector} from "../store/hooks/redux";
import LoginPage from "../pages/loginPage/LoginPage";
import {Navigate} from "react-router-dom";
import {AuthStatus} from "../models/StoreModels";
import Loading from "./Loading/Loading";

const AuthRouter = () => {
    const {authStatus} = useAppSelector(state => state.userReducer)

    if (authStatus === AuthStatus.Loading) {
        return <Loading/>;
    }

    if (authStatus === AuthStatus.Authorized) {
        return <Navigate to="/lesson" replace/>;
    }

    return <LoginPage/>;
};

export default AuthRouter;